import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Badge } from '../../../primitives/Rating/Snippet/components/Badge.js';
import { Body } from '../../../primitives/Rating/Snippet/components/Body.js';
import { Container } from '../../../primitives/Rating/Snippet/components/Container.js';
import { Description } from '../../../primitives/Rating/Snippet/components/Description.js';
import { Label } from '../../../primitives/Rating/Snippet/components/Label.js';
export const Snippet = /*#__PURE__*/_styled(forwardRef(({
  badge,
  label,
  description,
  contained = false,
  fullWidth = false,
  inverted = false,
  size = 'medium',
  ...restProps
}, ref) => _jsxs(Container, {
  ...restProps,
  ref: ref,
  contained: contained,
  fullWidth: fullWidth,
  inverted: inverted,
  size: size,
  children: [_jsx(Badge, {
    fullWidth: fullWidth,
    children: badge
  }), _jsxs(Body, {
    children: [label && _jsx(Label, {
      children: label
    }), description && _jsx(Description, {
      children: description
    })]
  })]
})), {
  label: 'RatingSnippet',
  target: "ezzpg1f0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNuaXBwZXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVUciLCJmaWxlIjoiU25pcHBldC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQmFkZ2UgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1JhdGluZy9TbmlwcGV0L2NvbXBvbmVudHMvQmFkZ2UuanMnO1xuaW1wb3J0IHsgQm9keSB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvUmF0aW5nL1NuaXBwZXQvY29tcG9uZW50cy9Cb2R5LmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvUmF0aW5nL1NuaXBwZXQvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgRGVzY3JpcHRpb24gfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1JhdGluZy9TbmlwcGV0L2NvbXBvbmVudHMvRGVzY3JpcHRpb24uanMnO1xuaW1wb3J0IHsgTGFiZWwgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1JhdGluZy9TbmlwcGV0L2NvbXBvbmVudHMvTGFiZWwuanMnO1xuZXhwb3J0IGNvbnN0IFNuaXBwZXQgPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBiYWRnZSwgbGFiZWwsIGRlc2NyaXB0aW9uLCBjb250YWluZWQgPSBmYWxzZSwgZnVsbFdpZHRoID0gZmFsc2UsIGludmVydGVkID0gZmFsc2UsIHNpemUgPSAnbWVkaXVtJywgLi4ucmVzdFByb3BzIH0sIHJlZikgPT4gKF9qc3hzKENvbnRhaW5lciwgeyAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjb250YWluZWQ6IGNvbnRhaW5lZCwgZnVsbFdpZHRoOiBmdWxsV2lkdGgsIGludmVydGVkOiBpbnZlcnRlZCwgc2l6ZTogc2l6ZSwgY2hpbGRyZW46IFtfanN4KEJhZGdlLCB7IGZ1bGxXaWR0aDogZnVsbFdpZHRoLCBjaGlsZHJlbjogYmFkZ2UgfSksIF9qc3hzKEJvZHksIHsgY2hpbGRyZW46IFtsYWJlbCAmJiBfanN4KExhYmVsLCB7IGNoaWxkcmVuOiBsYWJlbCB9KSwgZGVzY3JpcHRpb24gJiYgX2pzeChEZXNjcmlwdGlvbiwgeyBjaGlsZHJlbjogZGVzY3JpcHRpb24gfSldIH0pXSB9KSkpLCB7XG4gICAgbGFiZWw6ICdSYXRpbmdTbmlwcGV0Jyxcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9U25pcHBldC5qcy5tYXAiXX0= */");